import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import { trans, localStorageItemName } from '../utils';
import { Modal } from './Modal';

const acceptedFormats = ['.svg'];

export const UploadImage = ({ setIsUploadModalOpen, setMarkingImage }) => {
  const [isAccepted, setIsAccepted] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('');
  const [uploadedImgContentType, setUploadedImgContentType] = useState('image/svg');
  const [uploadedImgSrc, setUploadedImgSrc] = useState('');
  const [showExtensionMsg, setShowExtensionMsg] = useState(false);
  const [showMaxFileSizeMsg, setShowMaxFileSizeMsg] = useState(false);

  const inputRef = useRef(null);

  const checkExtension = file => {
    return new RegExp('(' + acceptedFormats.join('|').replace(/\./g, '\\.') + ')$').test(file);
  };

  const isDisabled = () => !isAccepted || !isFileUploaded;

  const handleAddFile = event => {
    setIsHovered(false);
    setShowMaxFileSizeMsg(false);
    const input = event.target;

    if (input.files[0] && checkExtension(input.value)) {
      if (input.files[0].size > 2097152) {
        setShowMaxFileSizeMsg(true);
        input.value = '';
        return;
      }
      setUploadedImgSrc(URL.createObjectURL(input.files[0]));
      const reader = new FileReader();
      reader.onload = e => {
        setUploadedImg(e.target.result);
        setShowExtensionMsg(false);
        setIsFileUploaded(true);
      };
      setUploadedImgContentType(input.files[0].type);
      reader.readAsArrayBuffer(input.files[0]);
    } else {
      setUploadedImgSrc('');
      setUploadedImg('');
      setShowExtensionMsg(true);
      setIsFileUploaded(false);
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const hashID = localStorage.getItem(localStorageItemName);
      const response = await axios.put(`/api/configurator_logo/${hashID}/`, uploadedImg, {
        headers: { 'Content-Type': uploadedImgContentType },
      });
      if (response.data) {
        setMarkingImage(response.data?.logo?.replace('jaguargift.com', 'luva.menu'));
      }
      setIsUploadModalOpen(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal handleClose={() => setIsUploadModalOpen(false)} title={trans('Przesyłanie logotypu')}>
      <div className="upload">
        <p>{trans('Dodaj lub zmień swoje logo')}</p>
        <p>
          {trans('Akceptowane typy plików')}: <b>{acceptedFormats.join(', ')}</b>
        </p>
        <p>{trans('Zalecamy użycie pliku z przezroczystym tłem.')}</p>
        <div>
          <div
            className={`vertical-center upload__zone ${isHovered ? 'hover' : ''}`}
            onDragEnter={() => setIsHovered(true)}
            onDragLeave={() => setIsHovered(false)}
          >
            <span className="upload__zone--message">
              <i className="fa-solid fa-upload fa-2x"></i>
              <br />
              <br />
              {trans('Przeciągnij i upuść logo tutaj lub kliknij, aby przeglądać...')}
            </span>
            <input
              className="upload__zone--input"
              type="file"
              name="logo"
              accept={acceptedFormats.join(', ')}
              onChange={e => handleAddFile(e)}
              ref={inputRef}
            ></input>
          </div>
          {showExtensionMsg && (
            <div className="alert alert-danger">
              <p>
                <i className="fa-sharp fa-solid fa-circle-info"></i>{' '}
                {trans('Wybrany format pliku nie jest obsługiwany.')}
              </p>
            </div>
          )}
          {showMaxFileSizeMsg && (
            <div className="alert alert-danger">
              <p>
                <i className="fa-sharp fa-solid fa-circle-info"></i> {trans('Maksymalny rozmiar pliku wynosi 2 MB.')}
              </p>
            </div>
          )}
          {uploadedImgSrc && <img src={uploadedImgSrc} alt="" className="upload__img"></img>}
        </div>
        <div className="form-group checkbox-group upload__rules">
          <input
            id="accept-upload-rules"
            type="checkbox"
            name="accept"
            onChange={() => setIsAccepted(!isAccepted)}
          ></input>
          <label htmlFor="accept-upload-rules">
            {trans(
              'Oświadczam, że posiadam prawa autorskie i majątkowe do wykorzystania nadsyłanego pliku graficznego.',
            )}
          </label>
        </div>
        <div className="form-group btn-group">
          <button onClick={() => setIsUploadModalOpen(false)} type="button" className="btn cancel-btn">
            {trans('Anuluj')}
          </button>
          <button onClick={() => handleSubmit()} type="button" className="btn confirm-btn" disabled={isDisabled()}>
            {isLoading && <i className="fas fa-circle-notch fa-spin"></i>}
            {trans('Dodaj')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

UploadImage.propTypes = {
  setIsUploadModalOpen: PropTypes.func.isRequired,
  setMarkingImage: PropTypes.func.isRequired,
};
